<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
      <div class="left">
        <p>欢迎登陆</p>
        <p class="line"/>
        <h1>华犇云管理<br>后台系统</h1>
      </div>
      <div class="right">
        <div class="title">
          <img src="../../../static/login-logo.png" alt="">
          <p>欢迎来到华犇云</p>
        </div>
        <el-form-item prop="username">
          <!-- <span class="svg-container">
            <svg-icon icon-class="user" />
          </span> -->
          <el-input
            v-model="loginForm.username"
            placeholder="输入后台登录账号"
            name="username"
            type="text"
            auto-complete="on"
          />
        </el-form-item>
        <el-form-item prop="password">
          <!-- <span class="svg-container">
            <svg-icon icon-class="password" />
          </span> -->
          <el-input
            :type="passwordType"
            v-model="loginForm.password"
            placeholder="输入登录密码"
            name="password"
            auto-complete="on"
            @keyup.enter.native="handleLogin" />
          <span class="show-pwd" @click="showPwd">
            <svg-icon icon-class="eye" />
          </span>
        </el-form-item>
        <el-button :loading="loading" type="primary" @click.native.prevent="handleLogin">{{ $t('login.logIn') }}</el-button>

      </div>
      <!-- <div class="title-container">
        <h3 class="title">{{ $t('login.title') }}</h3>
        <lang-select class="set-language"/>
      </div> -->

    </el-form>
    <el-dialog :title="$t('login.thirdparty')" :visible.sync="showDialog" append-to-body>
      {{ $t('login.thirdpartyTips') }}
      <br>
      <br>
      <br>
      <social-sign />
    </el-dialog>
    <el-link style="text-align: center;line-height: 30px;width:100%;color:white;position: fixed;bottom:0" @click="handleKip">© 华犇科技（广州）有限公司 huabenkeji.top 版权所有 粤ICP备2024226072号-1</el-link>
  </div>
</template>

<script>
// import { isvalidUsername } from '@/utils/validate'
import LangSelect from '@/components/LangSelect'
import SocialSign from './socialsignin'

export default {
  name: 'Login',
  components: { LangSelect, SocialSign },
  data() {
    const validateUsername = (rule, value, callback) => {
      // if (!isvalidUsername(value)) {
      //   callback(new Error('Please enter the correct user name'))
      // } else {
      callback()
      // }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码至少为6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: 'admin',
        password: '123456'
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      passwordType: 'password',
      loading: false,
      showDialog: false,
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }

  },
  created() {
    // window.addEventListener('hashchange', this.afterQRScan)
  },
  destroyed() {
    // window.removeEventListener('hashchange', this.afterQRScan)
  },
  methods: {
    handleKip() {
      window.open('http://beian.miit.gov.cn/')
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('LoginByUsername', this.loginForm).then(() => {
            this.loading = false
            this.$router.push({ path: this.redirect || '/' })
          }).catch(() => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    afterQRScan() {
      // const hash = window.location.hash.slice(1)
      // const hashObj = getQueryObject(hash)
      // const originUrl = window.location.origin
      // history.replaceState({}, '', originUrl)
      // const codeMap = {
      //   wechat: 'code',
      //   tencent: 'code'
      // }
      // const codeName = hashObj[codeMap[this.auth_type]]
      // if (!codeName) {
      //   alert('第三方登录失败')
      // } else {
      //   this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
      //     this.$router.push({ path: '/' })
      //   })
      // }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  /* 修复input 背景不协调 和光标变色 */
  /* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

  // /* reset element-ui css */
  // .login-container {
  //   .el-input {
  //     display: inline-block;
  //     height: 47px;
  //     width: 85%;
  //     input {
  //       background: transparent;
  //       border: 0px;
  //       -webkit-appearance: none;
  //       border-radius: 0px;
  //       padding: 12px 5px 12px 15px;
  //       color: $light_gray;
  //       height: 47px;
  //       caret-color: $cursor;
  //       &:-webkit-autofill {
  //         -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
  //         -webkit-text-fill-color: $cursor !important;
  //       }
  //     }
  //   }
  //   .el-form-item {
  //     border: 1px solid rgba(255, 255, 255, 0.1);
  //     background: rgba(0, 0, 0, 0.1);
  //     border-radius: 5px;
  //     color: #454545;
  //   }
  // }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$light_gray:#eee;
$cursor: rgb(47, 135, 235);
@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input{
    color: $cursor;
    &::first-line {
      color: $light_gray;
    }
  }
}
$bg:#2d3a4b;
$dark_gray:#889aa4;
$light_gray:#eee;
p{
   margin: 0;
}
.login-container {
  ::v-deep{
    .el-input {
      display: inline-block;
      height: 47px;
      width: 85%;
      input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: $light_gray;
        height: 47px;
        caret-color: $cursor;
        color: black;
        &:-webkit-autofill {
          -webkit-box-shadow: 0 0 0px 1000px #F7F7F7 inset !important;
          -webkit-text-fill-color: $cursor !important;
        }
      }
    }
    .el-form-item {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba($color: #C4C4C4, $alpha: 0.13);
      border-radius: 5px;
      color: #454545;
      border-radius: 36px;
      color: #999;
      overflow: hidden;
      height: 74px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 20px;
      &__content{
        width: 100%;
        display: flex;
        align-items: center;
      }
    }
    .el-button{
      height: 74px;
      font-size: 26px;
      width: 100%;
      border-radius: 74px;
      margin-top: 10px;
    }
  }
  position: fixed;
  height: 100%;
  width: 100%;
  background: url('../../../static/login-bg.png') no-repeat center/100% 100%;
  .login-form {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 302px - 357px);
    height: calc(100vh - 217px - 213px);
    display: flex;
    align-items: center;
    .left{
      background: url('../../../static/login-img.png') no-repeat center/100% 100%;
      height: calc(100% - 53px * 2);
      width: calc(100% - 543px);
      border-radius: 16px 0 0 16px;
      overflow: hidden;
      padding: 56px 52px;
      color: white;
      p{
        font-size: 44px;
        &.line{
          width: 42px;
          height: 3px;
          background-color: white;
          margin: 18px 0 17px;
        }
      }
      h1{
        font-size: 62px;
        font-weight: normal;
      }
    }
    .right{
      flex: 1;
      background-color: white;
      height: 100%;
      border-radius: 16px;
      overflow: hidden;
      padding: 22px 49px 0;
      .title{
        text-align: center;
        margin-bottom: 30px;
        img{
          width: 110px;
          // height: 110px;
        }
        p{
          font-size: 28px;
          color: #333;
        }
      }
      input{
        color: #999;
      }
    }
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }
  .title-container {
    position: relative;
    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
    .set-language {
      color: #fff;
      position: absolute;
      top: 5px;
      right: 0px;
    }
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .thirdparty-button {
    position: absolute;
    right: 35px;
    bottom: 28px;
  }
}
</style>
